import { render, staticRenderFns } from "./footfall.vue?vue&type=template&id=43f91c51&scoped=true&"
import script from "./footfall.vue?vue&type=script&lang=js&"
export * from "./footfall.vue?vue&type=script&lang=js&"
import style0 from "./footfall.vue?vue&type=style&index=0&id=43f91c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f91c51",
  null
  
)

export default component.exports